import { FollowUpAgentStatusEnum } from "Infrastructure/Api/Api";
import { SmartToyOutlined } from "@mui/icons-material";

export function useFollowupStatus() {
	const renderFollowupStatus = (status: FollowUpAgentStatusEnum) => {
		switch (status) {
			case FollowUpAgentStatusEnum.agent_started:
			case FollowUpAgentStatusEnum.in_progress:
				return {
					text: "⏳ Pending",
					color: "primary",
				};
			case FollowUpAgentStatusEnum.agent_abandoned:
			case FollowUpAgentStatusEnum.not_completed_timeout:
			case FollowUpAgentStatusEnum.not_completed_panic:
				return {
					text: "❌ Agent incomplete",
					color: "error",
				};
			case FollowUpAgentStatusEnum.agent_completed:
			case FollowUpAgentStatusEnum.quote_scope_confirmed:
			case FollowUpAgentStatusEnum.completed:
				return {
					text: "🤖 Agent completed",
					color: "success",
				};
			case FollowUpAgentStatusEnum.quote_requested_changes:
				return {
					text: "❗ Agent completed - requested changes",
					color: "success",
				};
			case FollowUpAgentStatusEnum.booking_deferred:
			case FollowUpAgentStatusEnum.booking_abandoned:
			case FollowUpAgentStatusEnum.quote_deferred:
				return {
					text: "❓ Agent completed - saved quote",
					color: "success",
				};
			case FollowUpAgentStatusEnum.booking_confirmed:
				return {
					text: "✅ Booking confirmed",
					color: "success",
				};
			case FollowUpAgentStatusEnum.booking_cancelled:
				return {
					text: "❌ Booking cancelled",
					color: "error",
				};
			default:
				return {
					text: "",
					color: "",
				};
		}
	};

	const renderFollowupStatusIcon = (
		status: FollowUpAgentStatusEnum,
	): JSX.Element => {
		switch (status) {
			case FollowUpAgentStatusEnum.agent_started:
			case FollowUpAgentStatusEnum.in_progress:
				return <SmartToyOutlined sx={{ color: "#3899EC" }} />;
			case FollowUpAgentStatusEnum.agent_abandoned:
			case FollowUpAgentStatusEnum.not_completed_timeout:
			case FollowUpAgentStatusEnum.not_completed_panic:
				return <SmartToyOutlined sx={{ color: "#EF4444" }} />;
			case FollowUpAgentStatusEnum.quote_deferred:
			case FollowUpAgentStatusEnum.quote_requested_changes:
			case FollowUpAgentStatusEnum.quote_scope_confirmed:
			case FollowUpAgentStatusEnum.booking_abandoned:
			case FollowUpAgentStatusEnum.booking_deferred:
			case FollowUpAgentStatusEnum.agent_completed:
			case FollowUpAgentStatusEnum.booking_confirmed:
			case FollowUpAgentStatusEnum.completed:
				return <SmartToyOutlined sx={{ color: "#10B981" }} />;
			case FollowUpAgentStatusEnum.booking_cancelled:
				return <SmartToyOutlined sx={{ color: "#EF4444" }} />;
			default:
				return <></>;
		}
	};

	return {
		renderFollowupStatusIcon,
		renderFollowupStatus,
	};
}
